import React from "react";
import "./Experience.css";

const Experience = () => {
  return (
    <div className="experience-div" id="experience">
  <h1 className="experience-title">Experience</h1>

  <div className="experience-card">
    <h2 className="experience-role">Software Engineer</h2>
    <h3 className="experience-company">WebMD</h3>
    <p className="experience-duration">May 2024 - Present</p>

    <ul className="experience-list">
      <li>Develop responsive HTML email templates.</li>
      <li>Convert Figma designs into production-ready UI.</li>
      <li>Ensure cross-browser compatibility.</li>
      <li>Collaborate with design and marketing teams.</li>
    </ul>
  </div>

  <div className="experience-card">
    <h2 className="experience-role">Frontend Developer</h2>
    <h3 className="experience-company">Tech Curve AI & Innovations</h3>
    <p className="experience-duration">Dec 2022 - Apr 2024</p>

    <ul className="experience-list">
      <li>Built responsive web modules using HTML, CSS and JavaScript.</li>
      <li>Implemented Figma-based UI designs.</li>
      <li>Created reusable frontend components.</li>
    </ul>
  </div>
</div>
  );
};

export default Experience;